<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :close-on-click-modal="false" :lock-scroll="false" :before-close="closeDialog">
    <div v-loading.fullscreen="loading">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item class="login_form_item" prop="userName">
          <div class="login_title">{{$t('RecipientName')}}</div>
          <el-input class="login_ipt" v-model="ruleForm.userName" :placeholder="$t('verify.RecipientName')" @input="setInput()"></el-input>
        </el-form-item>
        <el-form-item class="login_form_item" prop="mobile">
          <div class="login_title">{{$t('PhoneNumber')}}</div>
          <el-input class="login_ipt" v-model="ruleForm.mobile" :placeholder="$t('verify.PhoneNumber')" @input="setInput()"></el-input>
        </el-form-item>
        <el-form-item class="login_form_item" prop="email">
            <div class="login_title">{{$t('EmailAddress')}}</div>
            <el-input class="login_ipt" v-model="ruleForm.email" :placeholder="$t('verify.Email')"></el-input>
          </el-form-item>
        <el-form-item class="login_form_item" prop="provice">
          <div class="login_title">{{$t('Region')}}</div>
          <el-cascader class="login_ipt" popper-class="provinceList" separator=" " :placeholder="$t('verify.Region')" v-model="ruleForm.provice" :options="provinceList" @change="proviceChange"></el-cascader>
        </el-form-item>
        <el-form-item class="login_form_item" prop="address">
          <div class="login_title">{{$t('StreetAddress')}}</div>
          <el-input class="login_ipt" v-model="ruleForm.address" :placeholder="$t('verify.StreetAddress')" @input="setInput()"></el-input>
        </el-form-item>
        <div class="tips">
          <div>{{$t('MakePrimary')}}</div>
          <el-switch v-model="ruleForm.delivery"></el-switch>
        </div>
        <div class="tips" v-if="isSet"></div>
        <div class="login_btn_between">
          <el-button class="login_btn" @click="resetForm('ruleForm')">{{$t('Cancel')}}</el-button>
          <el-button class="login_btn" :disabled='disabled' type="primary" @click="submitForm('ruleForm')">{{$t('Confirm')}}</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import { getarea } from "@/api/area";
import { getInfo } from "@/api/public";
export default {
  name: 'getaddress',
  components: {},
  data() {
    return {
      userInfo:getInfo()||{},
      loading: false,
      provinceList: [],
      dislogType: this.$enumInfo.dislogType,
      disabled: true,
      dialogClass: 'address',
      proviceText: '',
      ruleForm: {
        userName: '',
        mobile: '',
        provice: [],
        address: '',
        email:'',
        delivery: false,
      },
      rules: {
        userName: [
          { required: true, message: this.$t('verify.RecipientName'), trigger: 'blur' },
        ],
        mobile: [
          { required: true, message: this.$t('verify.PhoneNumber'), trigger: 'blur' },
          { pattern: /^\+?[1-9]\d{1,14}$/, message: this.$t('verify.PhoneNumber'), trigger: 'blur' },
        ],
        email: [
          { required: true, message: this.$t('verify.Email'), trigger: 'blur' },
          { type:'email', message: this.$t('verify.Email'), trigger: 'blur' },
        ],
        provice: [
          { required: true, message: this.$t('verify.Region'), trigger: 'change' },
        ],
        address: [
          { required: true, message: this.$t('verify.StreetAddress'), trigger: 'blur' },
        ]
      },
    }
  },
  props: {
    list:{},
    isSet: Boolean,
    title: String,
    domVisible: Boolean,
  },
  created() {
    let that = this
    if(!that.userInfo.MemberSource || that.userInfo.MemberSource === 'CN'){
      that.getChinaAreas()
    }else{
      that.getOtherAreas(that.userInfo.MemberSource)
    }
    
  },
  mounted() {
    let that = this
    this.handleKeydown = (e) => {
      if (!this.disabled && e.keyCode === 13) {
        this.submitForm('ruleForm')
      }
    }
    window.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    if (this.handleKeydown) {
      window.removeEventListener('keydown', this.handleKeydown)
    }
  },
  methods: {
    getChinaAreas(){
      let that=this
      const currentCode = that._currentCountryCode
      that.$get(that.$interface.GetChinaAreas,'').then(res=>{
        if(res.Result){
          if(that._currentCountryCode !== currentCode) return
          that.provinceList=getarea(res.Data)
          that.setDetail(that.list)
        }else{
              that.$message.error(res.Msg);
            }

      })
      
    },
    getOtherAreas(code){
      let that=this
      const currentCode = that._currentCountryCode
      let data = { code: code }
      that.$get(that.$interface.GetAreas,data).then(res=>{
        // 检查是否是最新的请求
        if(that._currentCountryCode !== currentCode) return
        if(res.Result){
          that.provinceList=getarea(res.Data) || []
          that.setDetail(that.list)
        }else{
          that.$message.error(res.Msg);
        }
      })
    },

    // 编辑时填写默认值
    setDetail(val){
      if(!this.isSet){
        let provice=val.Provice;
        provice=provice.split('-')
        try{
          if(provice[0]===provice[1]){
            provice[1]='市辖区'
          }
        }catch(e){
          console.log(e)
        }
        this.ruleForm={
          userName: val.UserName,
          mobile: val.Mobile,
          provice: provice,
          email:val.Email,
          address: val.AddressDetail,
          delivery: val.IsDefault,
        }
        this.disabled = false
      }
    },
    // 关闭
    closeDialog(val) {
      this.$emit('closeDialog', 'address', false)
    },
    // 判断input是否有值
    setInput() {
      if (this.ruleForm.userName != '' && this.ruleForm.mobile != '' && this.ruleForm.provice.length > 0 && this.ruleForm.address != '') {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    // 所在区域 数组变成字符串 格式：xx-xx-xx
    proviceChange() {
      let that = this;
      that.setInput();
      //console.log(this.ruleForm,'this.ruleForm')
      let data = that.ruleForm.provice||[];
      if(!that.userInfo.MemberSource || that.userInfo.MemberSource === 'CN'){
        if(data.length>0){
          that.proviceText=data[0]+"-"+data[1]+"-"+data[2]
        }
      }else{
        that.proviceText=data[0]
      }
    },
    // 提交表单
    submitForm(formName) {
      let that = this;
      this.proviceChange();
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.disabled=true;
          that.loading=true;
          let city=that.proviceText
          let country=that.userInfo.Nation
          if(!that.userInfo.MemberSource || that.userInfo.MemberSource === 'CN'){
              city=that.ruleForm.provice[1]
              if(that.ruleForm.provice[1]==='市辖区'){
                city=that.ruleForm.provice[0]
              }
              country=that.$i18n.locale!='zh'?'China':'中国'
          }
          let data={
            memberId:that.userInfo._id,
            userName:that.ruleForm.userName,
            mobile:that.ruleForm.mobile,
            provice:that.proviceText,
            email:that.ruleForm.email,
            city:city,
            addressDetail:that.ruleForm.address,
            country:country,
            isDefault:that.ruleForm.delivery,
          }
          let url=that.$interface.SaveAddress
          // 是否编辑地址
          if(!that.isSet){
            data=Object.assign({}, data, {id:that.list._id})
            url=that.$interface.UpdateAddress
          }
          that.$post(url,data).then(res=>{
            if(res.Result!=0){
              that.closeDialog()
            }else{
              this.$message.error(res.Msg);
            }
            that.disabled=false;
            that.loading=false;
          })
        }
      });
    },
    // 清空表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.closeDialog()
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/address.css";

</style>



// WEBPACK FOOTER //
// src/components/dialog/address.vue